import { createSelector } from '@ngrx/store';

import { IUserInfo } from '@ruby/modules/account/models/contact.interface';
import { selectUnitTrainState, State } from '@ruby/modules/unit-train/store';
import * as fromUTOriginBatchWeigh from '@ruby/modules/unit-train/store/reducers/ut-origin-batch-weigh.reducer';
import { selectUserInfoState } from '@ruby/store/selectors/user-account.selectors';

export const selectOriginBatchWeight = createSelector(
  selectUnitTrainState,
  selectUserInfoState,
  (state: State, userInfo?: IUserInfo) => ({ state: state[fromUTOriginBatchWeigh.featureKey], userInfo })
);
